import Vue from 'vue';
import VueProgressBar from 'vue-progressbar';

const options = {
  color: '#00BCD4',
  failedColor: '#FF3834',
  thickness: '5px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300,
  },
  autoFinish: false,
  autoRevert: true,
  location: 'top',
  inverse: false,
};

Vue.use(VueProgressBar, options);
